import { render, staticRenderFns } from "./TabelaColunaCabecalho.vue?vue&type=template&id=1f85cd32&scoped=true&lang=pug"
import script from "./TabelaColunaCabecalho.vue?vue&type=script&lang=js"
export * from "./TabelaColunaCabecalho.vue?vue&type=script&lang=js"
import style0 from "./TabelaColunaCabecalho.styl?vue&type=style&index=0&id=1f85cd32&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f85cd32",
  null
  
)

export default component.exports